export const CHECKOUT_TRIGGER = 'checkout';
export const OPEN_SIGNIN_MODAL_METRIC = 'checkout_form.signin_modal_open';
export const SUCCESSFUL_SIGNIN_METRIC = 'checkout_form.signin_success';
